var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "w-32 bg-blue-400 flex justify-center",
      attrs: { "data-grm-comp": "RoomCBTTimer" },
    },
    [
      _c("div", { staticClass: "py-2 text-white text-2xl" }, [
        _vm._v(_vm._s(_vm.remainingTime)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }